import { render, staticRenderFns } from "./EditAssetTypeModal.vue?vue&type=template&id=16d2e88a&scoped=true&"
import script from "./EditAssetTypeModal.vue?vue&type=script&lang=js&"
export * from "./EditAssetTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./EditAssetTypeModal.vue?vue&type=style&index=0&id=16d2e88a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d2e88a",
  null
  
)

export default component.exports